require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2010-09-24-who-are-you-writing-code-for.json") })
        }
      }, "path---articles-2010-09-24-who-are-you-writing-code-for");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2010-09-24-who-are-you-writing-code-for!./.cache/json/articles-2010-09-24-who-are-you-writing-code-for.json
// module id = 598
// module chunks = 231608221292675